import { FormattedMessage } from 'gatsby-plugin-intl';
import React, { FC } from 'react';

import { ROUTER_PATHS } from '@constants/router';
import { useConstConfigs } from 'modules/Core';
import { logout, useSession } from 'modules/Session';

import {
  ACCOUNT_MENU_ITEMS,
  DOCS_MENU_ITEMS,
  DOCS_MENU_ITEMS_NO_COLLECTIONS,
  EMBEDDABLES_MENU_ITEMS,
  SUPPORT_MENU_ITEMS_FAQ,
} from '../../constants';
import { buildHeaderActions } from '../../utils';
import NavLink from '../NavLink';

type PropTypes = {
  className?: string;
  mobile?: boolean;
};

const NavBar: FC<PropTypes> = ({ className, mobile = false }) => {
  const { SHOW_CLIENT_ONLY_ROUTES, HIDE_COLLECTIONS } = useConstConfigs();

  const { ENABLE_WIDGETS } = useConstConfigs();

  const canSeeWidgets = ENABLE_WIDGETS;

  const CLIENT_ONLY_ITEMS = buildHeaderActions({ logout }).filter((item) =>
    canSeeWidgets ? true : item.href !== ROUTER_PATHS.WIDGETS
  );

  const [isAuthenticated] = useSession();

  return (
    <nav className={className}>
      <NavLink
        hasModules
        id="docs"
        mobile={mobile}
        items={HIDE_COLLECTIONS ? DOCS_MENU_ITEMS_NO_COLLECTIONS : DOCS_MENU_ITEMS}
      >
        <FormattedMessage id="core.header.docs" />
      </NavLink>
      <NavLink id="support" mobile={mobile} items={EMBEDDABLES_MENU_ITEMS}>
        <FormattedMessage id="core.header.embeddables" />
      </NavLink>
      <NavLink id="embeddables" mobile={mobile} items={SUPPORT_MENU_ITEMS_FAQ}>
        <FormattedMessage id="core.header.support" />
      </NavLink>
      {SHOW_CLIENT_ONLY_ROUTES && mobile && (
        <NavLink id="account" mobile items={isAuthenticated ? CLIENT_ONLY_ITEMS : ACCOUNT_MENU_ITEMS}>
          <FormattedMessage id="core.header.account" />
        </NavLink>
      )}
    </nav>
  );
};

export default NavBar;
